module.exports = __webpack_public_path__ + "img/lvzhou.4f0e30ad.png";